// extracted by mini-css-extract-plugin
module.exports = {"LocationForm":"LocationForm_LocationForm__2Aokm","Inputs":"LocationForm_Inputs__1uT3V"};